module.exports = __webpack_public_path__ + "static/img/third1_2_active.5505a764.png";